import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppForm } from '../../../../common/forms/app.form';
import {
  SurveyQuestionAnswerBaseAllBaseWriteSurveyQuestionAnswerAllSurveyQuestionAnswerWrite,
  SurveyQuestionBaseAllBaseReadSurveyAllSurveyReadSurveyItemRead
} from '../../../../openapi';

@Injectable()
export class SurveyForm extends AppForm {

  public validators = Validators;

  constructor() {
    super({
      questions: new FormArray([])
    });
  }

  public showControlError(ctrl: AbstractControl | null): boolean {
    return !!ctrl?.invalid && !!ctrl?.touched
  }

  public getFormGroup(index: number): FormGroup {
    return this.questions.at(index) as FormGroup;
  }

  public get questions(): FormArray {
    return this.controls['questions'] as FormArray;
  }

  public addQuestionGroup(v: SurveyQuestionBaseAllBaseReadSurveyAllSurveyReadSurveyItemRead): void {
    this.questions.push(this.createQuestionGroup(v));
  }

  private createQuestionGroup(v: SurveyQuestionBaseAllBaseReadSurveyAllSurveyReadSurveyItemRead): any {
    return new FormGroup({
      question: new FormControl(v.uuid, Validators.required),
      text: new FormControl('', v.type?.code === 'textarea' ? Validators.required : []),
      choices: new FormArray(this.createQuestionChoices(v) || [])
    });
  }

  private createQuestionChoices(v: SurveyQuestionBaseAllBaseReadSurveyAllSurveyReadSurveyItemRead): FormControl[] {
    switch (true) {
      case v?.type?.code === 'radio': {
        return [new FormControl(null, Validators.required)];
      }
      case v?.type?.code === 'checkbox': {
        return v?.surveyQuestionChoices?.map(() => new FormControl(false)) || [];
      }
      default:
        return [];
    }
  }

  public checkBoxChange(event: Event | null, choiceIndex: number, formGroup: FormGroup): void {
    const choices: FormArray = formGroup.controls['choices'] as FormArray;
    (choices.at(choiceIndex) as FormControl).setValue((event?.target as any)?.value || null);
  }

  public get values(): SurveyQuestionAnswerBaseAllBaseWriteSurveyQuestionAnswerAllSurveyQuestionAnswerWrite[] {
    const v: SurveyQuestionAnswerBaseAllBaseWriteSurveyQuestionAnswerAllSurveyQuestionAnswerWrite[] = this.value.questions;
    return v.map(j => ({
      ...j,
      choices: j.choices?.filter(v => !!v)
    }));
  }
}
